import { getDateAsMoment } from "../../../time"

export const dateParts = {
  DAY: "day",
  MONTH: "month",
  YEAR: "year"
}

export const defaultFieldOrder = [dateParts.DAY, dateParts.MONTH, dateParts.YEAR]
export const fieldMin = {
  [dateParts.DAY]: 1,
  [dateParts.MONTH]: 1,
  [dateParts.YEAR]: 1
}
export const fieldMax = {
  [dateParts.DAY]: 31,
  [dateParts.MONTH]: 12,
  [dateParts.YEAR]: 9999
}

export const breakDateIntoParts = dateString => {
  const date = getDateAsMoment(dateString)

  if (date && date.isValid()) {
    return {
      [dateParts.DAY]: Number(date.format("DD")),
      [dateParts.MONTH]: Number(date.format("MM")),
      [dateParts.YEAR]: Number(date.format("YYYY"))
    }
  }

  return {
    [dateParts.DAY]: "",
    [dateParts.MONTH]: "",
    [dateParts.YEAR]: ""
  }
}
